"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ControlTile;
var react_1 = __importDefault(require("react"));
var index_1 = require("web/components/primitives/index");
var styles_scss_1 = __importDefault(require("./styles.scss"));
function ControlTile(_a) {
    var title = _a.title, previewUrl = _a.previewUrl, links = _a.links, id = _a.id, onClick = _a.onClick;
    var isImageExtension = function (url) {
        return !!['jpeg', 'jpg', 'png', 'gif', 'webp'].find(function (ext) { return url.includes(ext); });
    };
    var renderPreview = function () {
        if (!previewUrl) {
            return null;
        }
        if (isImageExtension(previewUrl)) {
            return (react_1.default.createElement("div", { className: styles_scss_1.default.previewImageContainer, role: "img", "aria-label": "".concat(id, "-thumbnail"), style: { backgroundImage: "url(".concat(previewUrl, ")") } }));
        }
        return null;
    };
    return (react_1.default.createElement(index_1.FlexContainer, { flexDirection: "column", alignItems: "stretch", flex: 1, key: id, className: styles_scss_1.default.tile, onClick: function () { return onClick(id); } },
        react_1.default.createElement(index_1.FlexContainer, { flexDirection: "row", className: styles_scss_1.default.titleContainer },
            react_1.default.createElement(index_1.Icon, { size: 36, type: index_1.IconType.paperclip, className: styles_scss_1.default.titleIcon }),
            react_1.default.createElement(index_1.Text, { as: "h5", bold: true, pl: 1, className: styles_scss_1.default.tileTitle }, title)),
        renderPreview(),
        links && (react_1.default.createElement("div", { className: styles_scss_1.default.linkContainer },
            react_1.default.createElement(index_1.ButtonDropdown, { name: "collapsed-options", symbolIcon: index_1.IconType.moreVertical, type: index_1.ButtonType.floating, right: "0px", top: "-14px", links: links }))),
        react_1.default.createElement("div", { className: styles_scss_1.default.backdrop })));
}
